import React, { useState, useEffect } from 'react';
import { utcToZonedTime } from 'date-fns-tz';
import { Typography } from '@mui/material';

const CountdownTimer = ({ targetDate }) => {
  const CHAMORRO_TIME_ZONE = 'Pacific/Guam';

  const calculateTimeElapsed = () => {
    const now = utcToZonedTime(new Date(), CHAMORRO_TIME_ZONE);
    const target = new Date(targetDate);
    const difference = now - target;
    const timeElapsed = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
    return timeElapsed;
  };

  const [timeElapsed, setTimeElapsed] = useState(calculateTimeElapsed());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeElapsed(calculateTimeElapsed());
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return (
    // <div style={{
    //   backgroundColor: 'black',
    //   color: 'white',
    //   padding: '5px 10px',
    //   textAlign: 'center',
    //   borderRadius: '10px',
    //   boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
    //   width: '160px',
    //   margin: 'auto',
    // }}>
    //   <div style={{ display: 'flex', justifyContent: 'center' }}>
    //     {[
    //       { unit: 'days', label: 'D' },
    //       { unit: 'hours', label: 'H' },
    //       { unit: 'minutes', label: 'M' },
    //       { unit: 'seconds', label: 'S' }
    //     ].map(({ unit, label }) => (
    //       <div key={unit} style={{ margin: '0 5px', textAlign: 'center' }}>
    //         <div style={{
    //           fontSize: '1em',
    //           fontWeight: 'bold',
    //           position: 'relative',
    //           width: '30px',
    //           height: '30px',
    //           borderRadius: '50%',
    //           background: 'white',
    //           color: 'black',
    //           display: 'flex',
    //           alignItems: 'center',
    //           justifyContent: 'center',
    //         }}>
    //           {timeElapsed[unit]}
    //         </div>
    //         {/* <div style={{ fontSize: '0.7em' }}>{label}</div> */}
    //       </div>
    //     ))}
    //   </div>
    // </div>
    <div style={{display:"flex", gap:"5px"}}>
        {[
            { unit: 'days', label: 'days' },
            { unit: 'hours', label: 'hours' },
        ].map(({unit, label})=>(
            <Typography variant='body2'>{timeElapsed[unit]} {label}</Typography>
        ))}
    </div>
  );
};

export default CountdownTimer;
